import React from "react";
import QuestionPublicLink from "../../component/PublicLink/PublicLink";
import { QuizButton } from "../../types/GeneralStyles";
import { ResultScreen } from "../Webpage.components";

const CommunicatingResult = ({ result, overViewPage }) => {
  function leaveQuiz(result = false) {
    // 'result' should be a boolean: true for success, false for failure
    const url = window?.location?.href?.includes("localhost")
      ? "http://localhost:8000/"
      : "https://tools.vrtinnovatie.be/";
    window.parent.postMessage(result, url); // Replace with your actual parent domain
  }

  return (
    <ResultScreen
      style={{ marginTop: "10px" }}
      bgColor={result.theme_color}
      bgVisible={overViewPage}
      id={result.results_item_id}
    >
      <QuestionPublicLink
        overViewPage={overViewPage}
        type="result"
        quiz_item_id={result.results_item_id}
      />
      <QuizButton
        className="screenVisible"
        bgColor={result.theme_color}
        txtColor={result.theme_text_color}
        onClick={() => leaveQuiz(true)} // Use an arrow function to call leaveQuiz on click
      >
        Verlaat opdracht.
      </QuizButton>
    </ResultScreen>
  );
};

export default CommunicatingResult;
